import React from 'react';
import classNames from 'classnames';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import styles from 'components/admin/deviceDashboard/deviceEditor/DeviceSimulator.module.scss';

const CycleSelection = (props) => {
  const {
    cycles,
    onBack,
    onNext,
    onValueChange,
    selectedCycleName,
  } = props;

  return (
    <>
      <header className={styles.header}>
        <h4>Choose the cycle you want to simulate</h4>
      </header>
      <main className={styles.main}>
        <section className={styles.section}>
          <p>You can customize the status payload by selecting a specific cycle available to the machine</p>
          <Autocomplete
            disablePortal
            id="autocomplete-choose-cycle"
            getOptionLabel={(option) => option.label ?? option}
            options={cycles}
            sx={{ width: '300px' }}
            onChange={(event, value) => {
                onValueChange(value);
            }}
            renderInput={(params) => <TextField {...params} label="Cycle" />}
            value={selectedCycleName}
            isOptionEqualToValue={(option, value) => option.label === value}
          />
        </section>
      </main>
      <footer className={styles.footer}>
        <p className={styles.backButton} onClick={onBack}>
          Back
        </p>
        <button
          className={classNames(styles.backButton, {
            disabled: !selectedCycleName,
          })}
          disabled={!selectedCycleName}
          onClick={onNext}
        >
          Next
        </button>
      </footer>
    </>
  );
};

export default CycleSelection;
